import { isPaidSubscription } from '../data/plansConfig.js'

/**
 * The session to show when Firebase Auth has finished restoring and has no user.
 * Only synthetic local dev sessions live without Auth; any other cached profile
 * is stale, because API calls need auth.currentUser.
 */
export function sessionWithoutAuth(savedUser, savedPremium, isLocalSession) {
  if (savedUser && isLocalSession(savedUser)) {
    return {
      user: savedUser,
      isPremium: savedPremium === 'true' || isPaidSubscription(savedUser.subscription),
      clearCache: false
    }
  }
  return { user: null, isPremium: false, clearCache: true }
}
